$('#book-slider').owlCarousel({
    loop:true,
    margin:24,
    nav: false,
    dots: true,
    stagePadding: 100,
    responsiveClass:true,
    autoplay:true,
    autoplayTimeout:3000,
    autoplayHoverPause:true,
    responsive:{
        0:{
            items:1,
            stagePadding: 30,
            margin:10,
        },
        400:{
            items:1,
            margin:10,
        },
        576:{
            items:2,
            margin:10,
            stagePadding: 30,
        },
        768:{
            items:2,
            stagePadding: 50,
        },
        992:{
            items:3,
            margin:20,
        },
        1200:{
            items:4,
            loop:false,
            autoplay:false,
            stagePadding: 0,
        }
    }
})
$('#feminine-products-slider').owlCarousel({
    loop:true,
    margin:24,
    nav: false,
    dots: true,
    stagePadding: 100,
    responsiveClass:true,
    autoplay:true,
    autoplayTimeout:3000,
    autoplayHoverPause:true,
    responsive:{
        0:{
            items:1,
            stagePadding: 30,
            margin:10,
        },
        400:{
            items:1,
            margin:10,
        },
        576:{
            items:2,
            margin:10,
            stagePadding: 30,
        },
        768:{
            items:2,
            stagePadding: 50,
        },
        992:{
            items:3,
            margin:20,
        },
        1200:{
            items:4,
            loop:false,
            autoplay:false,
            stagePadding: 0,
        }
    }
})
$('#home-cleaning-product-slider').owlCarousel({
    loop:true,
    margin:24,
    nav: false,
    dots: true,
    stagePadding: 100,
    responsiveClass:true,
    autoplay:true,
    autoplayTimeout:3000,
    autoplayHoverPause:true,
    responsive:{
        0:{
            items:1,
            stagePadding: 30,
            margin:10,
        },
        400:{
            items:1,
            margin:10,
        },
        576:{
            items:2,
            margin:10,
            stagePadding: 30,
        },
        768:{
            items:2,
            stagePadding: 50,
        },
        992:{
            items:3,
            margin:20,
        },
        1200:{
            items:4,
            loop:false,
            autoplay:false,
            stagePadding: 0,
        }
    }
})
$('#logo-slider').owlCarousel({
    loop:true,
    margin:56,
    nav: false,
    dots: false,
    responsiveClass:true,
    autoplay:true,
    autoplayTimeout:3000,
    autoplayHoverPause:true,
    responsive:{
        0:{
            items:3,
            margin:20,
        },
        768:{
            items:4,
            stagePadding:20,
            margin:40,
        },
        1200:{
            items:5,
            loop:false,
            autoplay:false,
        }
    }
})
jQuery('#testimonial-slider').owlCarousel({
    loop:true,
    margin:20,
    nav: false,
    dots: true,
    responsiveClass:true,
    autoplay:true,
    autoplayTimeout:3000,
    autoplayHoverPause:true,
    responsive:{
        0:{
            items:1,
            margin:20
        },
    }
})

$('#mobi-testimonial-slider').owlCarousel({
    loop:true,
    margin:20,
    nav: false,
    dots: true,
    responsiveClass:true,
    autoplay:true,
    autoplayTimeout:3000,
    autoplayHoverPause:true,
    responsive:{
        0:{
            items:1,
            margin:20
        },
    }
})
$('#reviews-slider').owlCarousel({
    loop:true,
    margin:20,
    nav: false,
    dots: true,
    responsiveClass:true,
    autoplay:true,
    autoplayTimeout:3000,
    autoplayHoverPause:true,
    responsive:{
        0:{
            items:1,
            margin:20
        },
    }
})




$('#product-slider').owlCarousel({
    loop:true,
    margin:30,
    nav: false,
    dots: true,
    responsiveClass:true,
    autoplay:true,
    autoplayTimeout:3000,
    autoplayHoverPause:true,
    responsive:{
        0:{
            items:1,
        },
        400:{
            items:2,
            margin:10,
        },
        768:{
            items:2,
        },
        992:{
            items:3,
            margin:20,
        },
        1200:{
            items:4,
            loop:false,
            autoplay:false,
        }
    }
})